export default "__VITE_ASSET__63ed2f01__"